import React, { Component } from "react";
import ProfileIcon   from "../../resources/images/icon_profile.png";
import VitalsIcon    from "../../resources/images/icon_vitals.png";
import LaboratoryIcon from "../../resources/images/icon_lab.png";
import CommentsIcon  from "../../resources/images/icon_comments.png";
import CheckinIcon   from "../../resources/images/icon_checkin.png";
import CheckoutIcon  from "../../resources/images/icon_checkout.png";
import OrdersIcon    from "../../resources/images/icon_orders.png";
import HistoryIcon   from "../../resources/images/icon_history.png";
import TreatmentIcon from "../../resources/images/icon_treatment.png";
import { parseIntFromStr, GetCookieFunction } from '../../utils/util';

const ActionBtn = ({ href, icon, label, active }) => (
    <a href={href} className={`action-btn${active ? ' action-btn-active' : ''}`} data-tooltip={label} aria-label={label}>
        <img src={icon} alt={label} />
    </a>
);

const ScheduleBtn = ({ patientId, active }) => (
    <a href={`/patients/${patientId}/schedule`} className={`action-btn${active ? ' action-btn-active' : ''}`} data-tooltip="Schedule" aria-label="Schedule">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{opacity: 0.65}}>
            <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/>
        </svg>
    </a>
);

class PatientOptions extends Component {
    constructor(props) {
        super(props);
        this.state = {
            patientId:      parseIntFromStr(this.props.patientId),
            checkedIn:      this.props.checkedIn,
            dialysisStarted: this.props.dialysisStarted,
            parentContext:  this.props.parentContext,
            userType:       GetCookieFunction("User").type
        };
    }

    static getDerivedStateFromProps(props, state) {
        if (props.patientId !== state.patientId ||
            props.checkedIn !== state.checkedIn ||
            props.dialysisStarted !== state.dialysisStarted) {
            return {
                patientId:      parseIntFromStr(props.patientId),
                checkedIn:      props.checkedIn,
                dialysisStarted: props.dialysisStarted,
                parentContext:  props.parentContext
            };
        }
        return null;
    }

    render = () => {
        const { patientId, checkedIn, dialysisStarted, userType } = this.state;

        if (patientId === 0) return <></>;

        const id = patientId;
        const path = window.location.pathname;

        if (userType === "centeradmin" || userType === "executive") {
            return (
                <div className="action-btn-group">
                    <ActionBtn href={`/patients/${id}/profile`}      icon={ProfileIcon} label="Patient Profile" active={path.includes('/profile')} />
                    <ScheduleBtn patientId={id} active={path.includes('/schedule')} />
                    <ActionBtn href={`/patients/${id}/visit-history`} icon={HistoryIcon} label="Visit History" active={path.includes('/visit-history')} />
                </div>
            );
        }

        if (!checkedIn) {
            return (
                <div className="action-btn-group">
                    <ActionBtn href={`/patients/${id}/profile`}             icon={ProfileIcon}    label="Patient Profile" active={path.includes('/profile')} />
                    <ScheduleBtn patientId={id} active={path.includes('/schedule')} />
                    <ActionBtn href={`/patients/${id}/checkin`}             icon={CheckinIcon}    label="Check In" active={path.includes('/checkin')} />
                    <ActionBtn href={`/patients/${id}/recordLabReports/5`}  icon={LaboratoryIcon} label="Lab Reports" active={path.includes('/recordLabReports')} />
                    <ActionBtn href={`/patients/${id}/dialysisorder`}       icon={OrdersIcon}     label="Dialysis Order" active={path.includes('/dialysisorder')} />
                    <ActionBtn href={`/patients/${id}/visit-history`}       icon={HistoryIcon}    label="Visit History" active={path.includes('/visit-history')} />
                </div>
            );
        }

        return (
            <div className="action-btn-group">
                <ActionBtn href={`/patients/${id}/profile`}            icon={ProfileIcon}   label="Patient Profile" active={path.includes('/profile')} />
                <ScheduleBtn patientId={id} active={path.includes('/schedule')} />
                {!dialysisStarted && (
                    <ActionBtn href={`/patients/${id}/starttreatment`} icon={TreatmentIcon} label="Start Treatment" active={path.includes('/starttreatment')} />
                )}
                <ActionBtn href={`/patients/${id}/vitals`}             icon={VitalsIcon}    label="Record Vitals" active={path.includes('/vitals')} />
                <ActionBtn href={`/patients/${id}/doctorsComments`}    icon={CommentsIcon}  label="Doctor's Comments" active={path.includes('/doctorsComments')} />
                <ActionBtn href={`/patients/${id}/recordLabReports/5`} icon={LaboratoryIcon} label="Lab Reports" active={path.includes('/recordLabReports')} />
                <ActionBtn href={`/patients/${id}/checkout`}           icon={CheckoutIcon}  label="Check Out" active={path.includes('/checkout')} />
                <ActionBtn href={`/patients/${id}/visit-history`}      icon={HistoryIcon}   label="Visit History" active={path.includes('/visit-history')} />
            </div>
        );
    };
}

export { PatientOptions };
